export const PRIVS = {
    ADMIN: ['HOME', 'SETTINGS', 'APP_MANAGEMENT', 'REWARDS'],
    PARENT: ['HOME', 'SETTINGS', 'REWARDS'],
}